import * as S from "./MainTemplate.style";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import ContextMenu from "../../molecules/ContextMenu";
import useContextMenu from "../../../common/hooks/useContextMenu";
import { permissionsState } from "../../../common/states/permission";
import { Header } from "../../organisms/Header";
import { Sidemenu } from "../../organisms/Sidemenu";
import useMenuData from "src/common/hooks/useMenuData";
import TabList from "src/components/containers/Tabs/TabList";
import { readAccessToken } from "src/common/functions/authFunctions";
import { Navigate } from "react-router-dom";
import HomePage from "src/pages/home/HomePage";
import { openTabsState } from "src/states/menu";

interface MainTemplateProps {
  children: React.ReactElement;
  defaultComponent?: React.ReactElement;
}

export const MainTemplate = ({
  children,
  defaultComponent = <HomePage />,
}: MainTemplateProps) => {
  const accessToken = readAccessToken();
  useMenuData();

  const [asideOpen, setAsideOpen] = useState(true);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const permissions = useRecoilValue(permissionsState);
  const openTabs = useRecoilValue(openTabsState);
  const hasActiveTabs = openTabs && openTabs.length > 0;

  const {
    contextMenu,
    handleContextMenu,
    handleOpenInNewTab,
    handleOpenInNewWindow,
  } = useContextMenu();

  const resizeListener = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
      innerWidth < 1200 ? setAsideOpen(false) : setAsideOpen(true);
    };
  }, [innerWidth]);

  const handleAsideOpen = () => {
    setAsideOpen(!asideOpen);
  };

  if (!accessToken) {
    return <Navigate to="/auth/login" />;
  }

  return (
    <S.MainTemplate $asideOpen={asideOpen}>
      <Header
        asideToggle={handleAsideOpen}
        asideOpen={asideOpen}
        innerWidth={innerWidth}
      />
      <Sidemenu
        asideToggle={handleAsideOpen}
        onContextMenu={handleContextMenu}
        permissions={permissions ?? []}
      />
      <S.ContentSection>
        {/* 여기에 TabList추가하기 */}
        <TabList />
        {hasActiveTabs ? children : defaultComponent}
      </S.ContentSection>
      <ContextMenu
        handleOpenInNewTab={handleOpenInNewTab}
        handleOpenInNewWindow={handleOpenInNewWindow}
        visible={contextMenu.visible}
        x={contextMenu.x}
        y={contextMenu.y}
      />
    </S.MainTemplate>
  );
};
